<template>
  <v-row v-if="!loading">
    <bubble-chart
      :chart-data="bubbleData"
      :options="bubbleOptions"
      style="position: relative; width:92%; max-height: 250px; height: 250px;"
    />
  </v-row>
</template>

<script>
import BubbleChart from './BubbleChart.vue'
import { getDuration, roundToTwo } from '../Constants'
import moment from 'moment'

export default {
  props: {
    course: {
      type: Object,
      required: false
    },
    yLabel: {
      type: String,
      required: true
    },
    xLabel: {
      type: String,
      required: true
    },
    agent: {
      type: String,
      required: false,
      default: null
    },
    agentCoursesData: {
      type: Array,
      required: false,
      default: null
    },
    agentName: {
      type: String,
      required: false,
      default: null
    }
  },
  components: {
    BubbleChart
  },
  data() {
    return {
      bubbleOptions: {},
      bubbleData: {},
      leaderboardData: null,
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.setData()
    this.fillLeaderboard()
    this.loading = false
  },
  methods: {
    setData() {
      this.leaderboardData = new Array({ name: 'score', data: [] })
      if (
        this.agentCoursesData != null &&
        this.agentCoursesData !== undefined
      ) {
        this.agentCoursesData.forEach(element => {
          if (element.scoreLeaderBoard != null) {
            element.scoreLeaderBoard.forEach(e => {
              let scoreEle = _.find(this.leaderboardData[0].data, {
                name: e.name
              })
              if (scoreEle != null) {
                scoreEle.score += e.score
                scoreEle.interactionsCount += e.interactionsCount
                scoreEle.timeSpent = moment
                  .duration(scoreEle.timeSpent)
                  .add(e.timeSpent)
              } else {
                this.leaderboardData[0].data.push(e)
              }
            })
          }
        })
      } else {
        this.xMax = 0

        let leaderboard = new Array(
          { name: 'time', interactions: [] },
          { name: 'score', interactions: [] }
        )

        if (
          this.course.interactions != null &&
          this.course.interactions !== undefined
        ) {
          const sectionData = new Array()
          this.course.interactions.forEach(element => {
            if (element.duration != null && element.duration !== undefined) {
              element.duration = getDuration(element.duration)
            }

            if (
              element.verb === 'failed' ||
              element.verb === 'passed' ||
              element.verb === 'completed' ||
              element.verb === 'answered'
            ) {
              leaderboard[0].interactions.push(element)
            }
          })

          this.leaderboardData[0].data = _.chain(leaderboard[0].interactions)
            // Group the elements of Array based on `name` property
            .groupBy('name')
            // `key` is group's name (name), `value` is the array of interactions
            .map((value, key) => ({ name: key, interactions: value }))
            .value()
        }
      }
    },
    fillLeaderboard() {
      let bubble = new Array()
      let xMin,
        xMax = null

      const leaderboard = this.leaderboardData[0]

      let bgColor = this.agent == null ? 'rgba(255,255,255,0.2)' : new Array()
      leaderboard.data.forEach(element => {
        let score = 0
        let scoreCount = 0
        let intCount = 0
        if (
          this.agentCoursesData != null &&
          this.agentCoursesData !== undefined
        ) {
          bgColor.push(
            element.name === this.agentName
              ? '#E37225'
              : 'rgba(255,255,255,0.2)'
          )

          intCount = element.interactionsCount
          scoreCount = element.interactionsCount
          score += parseFloat(element.score)
          if (element.interactionsCount > xMax) {
            xMax = element.interactionsCount
          }

          if (element.interactionsCount < xMin) {
            xMin = element.interactionsCount
          }

          // if (timeSpent == null) {
          //   timeSpent = moment.duration(element.timeSpent)
          // } else {
          //   timeSpent = moment.duration(element.timeSpent).add(timeSpent)
          // }

          // if (maxTime == null) {
          //   maxTime = timeSpent
          // } else if (
          //   moment.duration(timeSpent).asSeconds() >
          //   moment.duration(maxTime).asSeconds()
          // ) {
          //   maxTime = timeSpent
          // }
        } else {
          if (xMax == null || element.interactions.length > xMax) {
            xMax = element.interactions.length
          }

          if (xMin == null || element.interactions.length < xMin) {
            xMin = element.interactions.length
          }

          if (this.agent != null) {
            bgColor.push(
              element.userId === parseInt(this.agent)
                ? '#E37225'
                : 'rgba(255,255,255,0.2)'
            )
          }
          element.interactions.forEach(ele => {
            if (ele.score != null && ele.score !== undefined) {
              score += parseFloat(ele.score)
              scoreCount++
            } else {
              intCount++
            }
          })
        }
        bubble.push({ x: intCount, y: score / scoreCount, r: 15 })
      })

      xMax = parseInt(xMax)

      this.bubbleData = {
        datasets: [
          {
            metadata: leaderboard.data,
            backgroundColor: bgColor,
            borderColor: '#E37225',
            data: bubble
          }
        ]
      }

      this.bubbleOptions = {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return data['labels'][tooltipItem[0]['index']]
            },
            label: function(tooltipItem, data) {
              const leaderData =
                data['datasets'][0]['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (leaderData !== undefined && leaderData != null) {
                toolTip.push(leaderData.name)
                let intCount = 0
                let scoreCount = 0
                let score = 0
                let timeSpent = null
                leaderData.interactions.forEach(element => {
                  if (element.score != null && element.score !== undefined) {
                    scoreCount++
                    score += parseFloat(element.score)
                  } else {
                    intCount++
                    if (
                      element.duration !== undefined &&
                      element.duration != null
                    ) {
                      if (timeSpent == null) {
                        timeSpent = moment.duration(element.duration)
                      } else {
                        timeSpent = moment
                          .duration(element.duration)
                          .add(timeSpent)
                      }
                    }
                  }
                })
                toolTip.push(`Interactions: ${intCount}`)
                toolTip.push(`Score: ${roundToTwo(score / scoreCount)}%`)
                toolTip.push(`Time Spent: ${getDuration(timeSpent)}`)
                // if (timeSpentCount.timeSpentItems.length > TOTAL_ITEMS) {
                //   const diff =
                //     timeSpentCount.timeSpentItems.length - TOTAL_ITEMS
                //   toolTip.push(`and ${diff} more`)
                // }
              }
              return toolTip
            }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000'
          //yAlign: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              // type: 'time',
              // distribution: 'series',
              // time: {
              //   displayFormats: {
              //     minute: 'h:mm:ss'
              //   }
              // },
              ticks: {
                max: 100,
                min: 0,
                stepSize: 25
              },
              scaleLabel: {
                display: true,
                labelString: this.yLabel
              }
            }
          ],
          xAxes: [
            {
              distribution: 'linear',
              scaleLabel: {
                display: true,
                labelString: this.xLabel
              },
              ticks: {
                max: xMax
                //min: xMin
              }
            }
          ]
        }
      }
    }
  }
}
</script>

<style>
.bubble-chart {
  max-height: 250px;
  height: 250px;
  width: 90%;
  position: relative;
}
</style>
